<template>
  <li class="package-item"
    @click="$emit('select',item)">
    <img class="avatar"
      :src="cos_prefix + item.p_img_small"
      :onerror="defaultLogo">
    <div class="info">
      <h4>{{item.package_name}}</h4>
      <div class="detail">
        <span class="price">&yen;{{item.price}}</span>
        <button>抢购</button>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      defaultLogo,
      cos_prefix
    }
  }
}
</script>

<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

@color-theme: #ff8008;
.package-item {
  color: #485464;
  display: flex;
  margin-top: 30/200rem;
  .avatar {
    width: 180/200rem;
    height: 136/200rem;
    border-radius: 16/200rem;
    border: 1/200rem solid rgba(222, 222, 222, 1);
    margin-right: 30/200rem;
    object-fit: cover;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    h4 {
      width: 416/200rem;
      font-size: 32/200rem;
      font-weight: 400;
      line-height: 44/200rem;
      .ellipsis(416/200rem);
    }
    .detail {
      display: flex;
      justify-content: space-between;
      .price {
        font-size: 32/200rem;
        color: @color-theme;
      }
      button {
        color: #fff;
        width: 108/200rem;
        height: 48/200rem;
        border-radius: 26/200rem;
        background: linear-gradient(
          90deg,
          rgba(247, 159, 42, 1) 0%,
          rgba(255, 128, 8, 1) 100%
        );
      }
    }
  }
}
</style>
